import { cn } from '../../lib/utils';

/** Shimmering placeholder block. Compose several for skeleton screens. */
export default function Skeleton({ className }) {
  return (
    <div
      className={cn(
        'shimmer rounded-md bg-white/[0.04] border border-white/[0.04]',
        className
      )}
    />
  );
}

/** Convenience: a multi-line text skeleton. */
export function SkeletonText({ lines = 3, className }) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className="h-3"
          // last line shorter
          style={undefined}
        />
      ))}
    </div>
  );
}
